import React, { useState } from 'react';
import { FlowCanvas } from './flow-canvas';
import { ControlBar } from './control-bar';
import { LogType } from '../types/visualizer';
import { InfoBar } from './info-bar';

import { Spinner } from '@@/ui/components';
import { useContact } from '../hooks/use-contact';

export function RemoteFlowVisualization(props: { contactId: string; onClose: () => void }) {
  const { data: contact, isLoading: isContactLoading } = useContact(props.contactId);
  const [logType, setLogType] = useState<LogType>(LogType.FLOW_LOG);

  const allowedLogTypes = [LogType.FLOW_LOG, LogType.INTERACTION_LOG];

  if (!contact || isContactLoading) {
    return (
      <div className='flex items-center justify-center h-full text-neutral-500'>
        <Spinner />
      </div>
    );
  }

  return (
    <div className='flex-1 flex flex-col h-full relative'>
      <InfoBar
        allowedLogTypes={allowedLogTypes}
        initiationTimestamp={contact.InitiationTimestamp as unknown as string}
        contactId={props.contactId}
        relatedContactId={contact?.RelatedContactId}
        previousContactId={contact?.PreviousContactId}
        selectedLogType={logType}
        onLogTypeChange={setLogType}
        onClose={props.onClose}
      />
      <div className='flex-1'>
        <FlowCanvas
          key={`${logType}-${props.contactId}`}
          selectedLogType={logType}
          contactId={props.contactId}
          initiationTimestamp={contact.InitiationTimestamp as unknown as string}
          disconnectTimestamp={contact.DisconnectTimestamp as unknown as string | null}
        />
      </div>
      {contact ? (
        <ControlBar contact={contact} contactId={props.contactId} />
      ) : (
        <div className='h-10 bg-white border-neutral-200 flex items-center justify-between px-3 border-t'>
          <Spinner className='size-5 text-neutral-400' />
        </div>
      )}
    </div>
  );
}
